import { useState, useEffect } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastNotification = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true); // Show toast on page load
  }, []);

  const handleClose = () => setShow(false);

  return (
    <ToastContainer
      position="bottom-start"
      className="p-3 sticky-toast-container"
    >
      <Toast show={show} onClose={handleClose} autohide delay={10000}>
        <Toast.Header>
          <strong className="me-auto">Welcome!</strong>
        </Toast.Header>
        <Toast.Body>To get the most out of your experience, please enable third-party cookies in your browser settings.</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastNotification;